
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trade-customers",
      function () {
        return require("private-next-pages/trade-customers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trade-customers"])
      });
    }
  